// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button[data-v-716898d6] {\n  text-transform: capitalize;\n  padding: 0 5px;\n}", "",{"version":3,"sources":["webpack://./src/components/ScrollPage/scrollAnchor.vue"],"names":[],"mappings":"AACA;EACI,0BAAA;EACA,cAAA;AAAJ","sourcesContent":["\nbutton{\n    text-transform: capitalize;\n    padding:0 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
